import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { CouponExternalRequestBody, CouponExternalResponse } from "./types";

export class CouponExternalAPI extends BaseAPI<
  CouponExternalRequestBody,
  CouponExternalResponse
> {
  protected route = ApiRoutes.coupon.external;
  protected method = RequestMethod.POST;
}
